import { Button } from '../ui/Button';
import type { Selection } from './useSelection';

/**
 * What you can do with a handful of tiles once you've picked them: put them
 * somewhere else, take a copy, or throw them away.
 *
 * It replaces the header's tools rather than sitting under them — with a
 * selection on screen, "Add Item" is not what anyone is about to press.
 */
export function SelectionBar({
  selection,
  exporting,
  onMove,
  onExport,
  onDelete,
}: {
  selection: Selection;
  exporting: boolean;
  onMove: () => void;
  onExport: () => void;
  onDelete: () => void;
}) {
  const count = selection.count;

  return (
    <div className="board__selection" role="toolbar" aria-label="Selected items">
      <p className="board__selected" role="status">
        {count} selected
      </p>

      <Button variant="quiet" onClick={onMove}>
        Move To Room
      </Button>
      <Button variant="quiet" onClick={onExport} disabled={exporting}>
        {exporting ? 'Exporting…' : 'Export'}
      </Button>
      <Button variant="quiet" onClick={onDelete}>
        Delete
      </Button>

      <button type="button" className="board__dismiss" onClick={selection.clear}>
        Clear
      </button>
    </div>
  );
}
